import "./components/Header.module.scss";

import { DesktopHeader } from "./components/DesktopHeader";

export const Header = { DesktopHeader };
